const state = {
    editVariation: null,
    variationRemoved: false,
}

export default state;